const IMAGE_ASSET_PATH_PREFIX = 'waysprite-scene-image://';

const inMemorySceneImageAssets = new Map<string, string>();

export const createSceneImageAssetPath = (assetId: string): string =>
  `${IMAGE_ASSET_PATH_PREFIX}${assetId}`;

export const parseSceneImageAssetPath = (value: string): string | null => {
  if (!value.startsWith(IMAGE_ASSET_PATH_PREFIX)) {
    return null;
  }
  const assetId = value.slice(IMAGE_ASSET_PATH_PREFIX.length).trim();
  return assetId.length > 0 ? assetId : null;
};

export const persistSceneImageAsset = (assetId: string, imagePath: string): void => {
  if (!assetId.trim() || !imagePath.trim()) {
    return;
  }
  inMemorySceneImageAssets.set(assetId, imagePath);
};

export const readSceneImageAsset = (assetId: string): string | null => {
  return inMemorySceneImageAssets.get(assetId) ?? null;
};

export const resolveSceneImageAssetPath = (value: string): string => {
  const assetId = parseSceneImageAssetPath(value);
  if (!assetId) {
    return value;
  }
  return readSceneImageAsset(assetId) ?? '';
};

export const deleteSceneImageAssets = (sceneId: string): void => {
  const trimmedSceneId = sceneId.trim();
  if (!trimmedSceneId) {
    return;
  }
  const scenePrefix = `${trimmedSceneId}:`;

  for (const assetId of [...inMemorySceneImageAssets.keys()]) {
    if (assetId.startsWith(scenePrefix)) {
      inMemorySceneImageAssets.delete(assetId);
    }
  }
};
